
import jp from 'jsonpath'

export function hasValue(value: any, skipZero?: boolean) {

    if (skipZero && typeof value == "number" && value == 0) return true
    if (!value) return false
    switch (typeof value) {
        case 'string':
            return value?.trim().length > 0
        case 'number':
            return value > 0
        default:
            return true
    }
}

export function isDefined(value: any) {
    return value !== undefined
}

export function tryParseJSON(x: string, def: any = null) {
    try {
        return JSON.parse(x);
    } catch {
        return def;
    }
}

interface ICallback {
    (): void
}
function loadScriptFile(path: string, callback?: ICallback, id?: string,) {

    let exist = false
    if (id) {
        // check if an element exist with given id 
        let element = document.getElementById(id)
        if (element) {
            exist = true
            console.log("script already added. ", id, path)
        }
    }

    if (!exist) {
        var script = document.createElement('script');

        script.onload = function () {
            if (typeof callback == "function") {
                callback();
            }
        };

        if (id) {
            script.setAttribute('id', id);
        }
        script.setAttribute('src', path);
        document.head.appendChild(script);
    }
}

export function loadScriptFileAsync(path: string): Promise<void> {
    return new Promise((resolve, reject) => {
        loadScriptFile(path, () => resolve());
    });
}
export function hasProperty(data: any, path: string) {
    return isPathValid(data, path)
}

export function isPathValid(data: any, path: string) {
    try {
        let paths = jp.paths(data, path)
        return paths.length > 0

    } catch (e) {
        return false;
    }
}